import React from 'react';
import { usePrioritiesPage } from '../controllers/priorities-page';
import { PrioritiesPageView } from './main';

export default function PrioritiesPage() {
	const prioritiesPageProps = usePrioritiesPage();

	return <PrioritiesPageView {...prioritiesPageProps} />;
}
